module.exports = __webpack_public_path__ + "img/cross.c5641ea2.svg";